import React from 'react'
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FileDownloadIcon from '@mui/icons-material/FileDownload';import "./QuotationTopButtons.css"

import EditIcon from '@mui/icons-material/Edit';

function QuotationTopButtons() {
  return (
    <div className="d-flex app">
    <div
      className="container-fluid ordersummary-top-button-main"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <div
        className="d-flex flex-column w-100"
        style={{ backgroundColor: "#F4F4F4" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            height:"48px"
          }}
        >
          <div>
            <h1 className="mobile-top-button-head-hide p-0" style={{ fontSize: "24px", marginBottom: "2rem"}}>
            Quotation & Payment Details  | <HomeOutlinedIcon style={{color:"#5B489D",width:"34px",height:"27px"}}/>{" "}
              <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt; Order List</span> {" "}
              <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt; Quotation & Payment Details</span>
            </h1>
            <h1 className="mobile-top-button-head-show" style={{ fontSize: "24px", marginBottom: "2rem"}}>
               <HomeOutlinedIcon style={{color:"#5B489D",width:"27px",height:"22px"}}/>{" "}
              <span style={{ fontSize: "16px",color:"#6A6A6A" }}>&gt; Order List</span> {" "}
              <span style={{ fontSize: "16px",color:"#6A6A6A" }}>&gt; Quotation & Payment Details</span>
            </h1>
          </div>
        </div>
        <div>

      </div>
    </div>
      </div>
    </div>
  )
}

export default QuotationTopButtons